import { Grid, ListSubheader, Select } from "@material-ui/core";
import List from "@material-ui/core/List";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import CheckBoxIcon from "@material-ui/icons/CheckBox"; // icone de selecionar todos em massa
import SortByAlphaIcon from "@material-ui/icons/SortByAlpha";
import GroupIcon from "@material-ui/icons/Group";
import MarkUnreadChatAltIcon from "@mui/icons-material/MarkUnreadChatAlt";
import SmsFailedIcon from "@mui/icons-material/SmsFailed";
import FilterListOffIcon from "@mui/icons-material/FilterListOff";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";
import { Box, Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { useContext, useEffect, useReducer, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";
import socket from "../../hooks/useSocket";
import useTickets from "../../hooks/useTickets";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import BatchConclusionMessages from "../BatchConclusionMessages"; // componente de conclusao de ticket em massa
import BatchTagModal from "../BatchTagModal"; // componente de vincular etiqueta em massa
import ContactListItem from "../ContactListItem";
import SelectAction from "../SelectAction/SelectAction";
import TicketListItem from "../TicketListItem";
import TicketsListSkeleton from "../TicketsListSkeleton";
import FilteredTickets from "../../helpers/FilteredTickets";
// import { useDrafts } from "../../helpers/DraftsNew";
import GetUrlTicketPath from "../../helpers/GetUrlTicketPath";
import GeneralActions from "../../helpers/GeneralActions";
import BatchTransferModal from "../Ticket/batchTransferModal";

const removeDuplicated = (tickets, status) => {
  let filteredTickets = tickets.filter((ticket) => {
    // Verifica se o ticket tem o status correspondente
    if (status === "open" || status === "closed" || status === "pending") {
      return ticket.status === status;
    } else {
      return true; // Se status não for especificado ou não corresponder aos status conhecidos, mantém o ticket
    }
  });

  let uniqueTicketsList = filteredTickets.reduce(
    (accumulator, currentValue) => {
      // Verifica se o id do objeto atual já está presente na lista acumuladora
      let found = accumulator.some((item) => item.id === currentValue.id);

      // Se o id não estiver presente, adiciona o objeto à lista acumuladora
      if (!found) {
        accumulator.push(currentValue);
      }

      return accumulator;
    },
    []
  );

  return filteredTickets;
};

const useStyles = makeStyles((theme) => ({
  ticketsListWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },

  ticketsList: {
    flex: 1,
    overflowY: "scroll",
    ...theme.scrollbarStyles,
    borderTop: "2px solid rgba(0, 0, 0, 0.12)",
  },

  ticketsListHeader: {
    color: "rgb(67, 83, 105)",
    zIndex: 2,
    backgroundColor: "white",
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  ticketsCount: {
    fontWeight: "normal",
    color: "rgb(104, 121, 146)",
    marginLeft: "8px",
    fontSize: "14px",
  },

  noTicketsText: {
    textAlign: "center",
    color: "rgb(104, 121, 146)",
    fontSize: "14px",
    lineHeight: "1.4",
  },

  noTicketsTitle: {
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "600",
    margin: "0px",
  },

  noTicketsDiv: {
    display: "flex",
    height: "100px",
    margin: 40,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  checkedIcon: {
    backgroundColor: "#137cbd",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  },
  contactTitle: {
    fontSize: "1.1rem",
    margin: "10px 0 10px 10px!important",
    color: "rgba(0, 0, 0, 0.54)!important",
    fontWeight: "700!important",
  },
  actionIcons: {
    cursor: "pointer",
    marginLeft: "5px",
    height: "20px",
    [theme.breakpoints.down("960")]: {
      marginLeft: "10px",
    },
  },
}));

const reducer = (state, action) => {
  const statusTab = action.status;

  if (action.type === "LOAD_TICKETS") {
    const tkcts = action.payload;
    let newTickets = [];

    tkcts.forEach((ticket) => {
      const ticketIndex = newTickets.findIndex((t) => t.id === ticket.id);
      if (ticketIndex !== -1) {
        newTickets[ticketIndex] = ticket;
        if (ticket.unreadMessages > 0) {
          newTickets.unshift(newTickets.splice(ticketIndex, 1)[0]);
        }
      } else {
        newTickets.push(ticket);
      }
    });

    // Remove duplicados mantendo apenas o primeiro de cada id
    const uniqueTickets = [...state, ...newTickets].filter(
      (tck, index, self) => index === self.findIndex((t) => t.id === tck.id)
    );
    return uniqueTickets;
  }

  if (action.type === "RESET_UNREAD") {
    const { ticketId, lastMessage } = action.payload || {};
    const ticketIndex = state.findIndex((t) => t.id === ticketId);
    if (ticketIndex !== -1) {
      state[ticketIndex].unreadMessages = 0;
      if (lastMessage) state[ticketIndex].lastMessage = lastMessage;
    }
    return [...state];
  }

  if (action.type === "UPDATE_TICKET") {
    const ticket = action.payload;

    const ticketIndex = state.findIndex(
      (t) => t.id == ticket.id && t.uuid == ticket.uuid
    );
    if (statusTab && ticket.status !== statusTab) {
      if (ticketIndex != -1) {
        state.splice(ticketIndex, 1);
        return [...state];
      } else return [...state];
    }

    if (ticketIndex !== -1) {
      state[ticketIndex] = ticket;
    } else {
      state.unshift(ticket);
    }

    return [...state];
  }

  if (action.type === "UPDATE_TICKET_UNREAD_MESSAGES") {
    const ticket = action.payload;
    if (!ticket?.queueId) return [...state];
    const ticketIndex = state.findIndex(
      (t) => t.id == ticket.id && t.uuid == ticket.uuid
    );
    if (ticketIndex !== -1) {
      state[ticketIndex] = ticket;
      state.unshift(...state.splice(ticketIndex, 1));
    } else {
      state.unshift(ticket);
    }
    return [...state];
  }

  if (action.type === "UPDATE_TICKET_CONTACT") {
    const contact = action.payload;
    if (contact) {
      const ticketIndex = state.findIndex((t) => t.contactId === contact?.id);
      if (ticketIndex !== -1) {
        state[ticketIndex].Contact = contact;
      }
    }
    return [...state];
  }

  if (action.type === "DELETE_TICKET") {
    const ticketId = action.payload;
    const ticketIndex = state.findIndex((t) => t.id === ticketId);
    if (ticketIndex !== -1) {
      // verificar se o atendimento está aberto na tela
      const currentUuid = GetUrlTicketPath();
      const tckt = state[ticketIndex];
      if (tckt && currentUuid == tckt.uuid) {
        setTimeout(() => {
          const btnClose = document.querySelector("#btnCloseTicketOnHeader");
          if (btnClose) btnClose.click();
        }, 1000);
      }

      state.splice(ticketIndex, 1);
    }

    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }

  // Retorne o estado original se nenhuma ação corresponder
  return state;
};

const TicketsList = ({
  status,
  selectedStatus,
  searchParam,
  showAll,
  tagsFilter,
  connectionsAndQueues,
  searchByMessages,
  handleSearch,
  pageNumber,
  setPageNumber,
  hasWaBusinessModule = false,
}) => {
  const classes = useStyles();
  const [pressed, setPressed] = useState(false);
  const [onlyGroups, setOnlyGroups] = useState(false);
  const [onlyExpiredWaBusiness, setOnlyExpiredWaBusiness] = useState(false);
  const [order, setOrder] = useState("DESC");
  const [ticketsList, dispatch] = useReducer(reducer, []);
  const [sortedTicketList, setSortedTicketList] = useState(ticketsList);
  const [sortedUnreadTickets, setSortedUnreadTickets] = useState(ticketsList);
  const Icon = KeyboardDoubleArrowDownIcon;
  const { user } = useContext(AuthContext);
  const { adminId, profile, queues } = user;
  const [conclusionModalOpen, setConclusionModalOpen] = useState(false); // close ticket modal
  const [tagModalOpen, setTagModalOpen] = useState(false); // tag modal
  const [transferModalOpen, setTransferModalOpen] = useState(false); // transfer modal
  const [selectedTickets, setSelectedTickets] = useState([]);
  const history = useHistory();
  const [searchContacts, setSearchContacts] = useState([]);
  const [totalTickets, setTotalTickets] = useState([]);
  // const { drafts } = useDrafts();

  const unSelectAll = () => {
    setSelectedTickets([]);
    if (handleSearch) handleSearch("");
  }

  useEffect(() => {
    let isMounted = true;
    const abortController = new AbortController();

    async function getTotalTickets() {
      try {
        const { data } = await api.get("/tickets/getTotal", {
          params: { status },
          signal: abortController.signal,
        });
        if (!isMounted) return;
        return data;
      } catch (error) {
        if (!isMounted || error.name == "AbortError") return;
        console.error(error);
        throw error;
      }
    }

    (async () => {
      try {
        const { total } = await getTotalTickets();
        setTotalTickets(total);
      } catch (error) {
        // Trate os erros de forma apropriada aqui
        console.error(error);
      }
    })();

    return () => {
      // socket.off(draftEventName, draftEventFunction);
      isMounted = false;
      abortController.abort();
    };
  }, []);

  const handleSelectAll = () => {
    if (selectedTickets.length === ticketsList.length) {
      setSelectedTickets([]);
      return;
    }
    const allTicketIds = ticketsList.map((ticket) => ticket.id);
    setSelectedTickets(allTicketIds);
  };

  // manipulando o modal de finalizacao em massa
  const showBatchConclusionMessages = () => {
    setConclusionModalOpen(true);
  };

  const hideBatchConclusionMessages = () => {
    setConclusionModalOpen(false);
    setSelectedTickets([]);
  };

  // manipulando o modal de transferencia em massa
  const showBatchTransferModal = () => {
    setTransferModalOpen(true);
  };

  const hideBatchTransferModal = () => {
    setTransferModalOpen(false);
  };

  // manipulando o modal de tags em massa
  const showTagModalOpen = () => {
    setTagModalOpen(true);
  };

  const hideTagModalOpen = () => {
    setTagModalOpen(false);
    setSelectedTickets([]);
  };

  useEffect(() => {
    const getSortDate = (ticket) => {
      return new Date(ticket?.lastMessageDate).getTime();
    };

    const sortTickets = (tickets) => {
      return [...tickets].sort((a, b) => {
        const dateA = getSortDate(a);
        const dateB = getSortDate(b);
        return order === "ASC" ? dateA - dateB : dateB - dateA;
      });
    };

    const unreadTicketsList = ticketsList.filter(
      (ticket) => ticket.unreadMessages > 0
    );

    const sortedTickets = sortTickets(ticketsList);
    const sortedUnreadTicketsList = sortTickets(unreadTicketsList);

    const unifiedIds = removeDuplicated(sortedTickets, status);
    setSortedTicketList(unifiedIds);
    setSortedUnreadTickets(sortedUnreadTicketsList);
  }, [order, ticketsList]);

  const handleCheckboxChange = (clickedTicket) => {
    setSelectedTickets((prevSelectedTickets) => {
      if (prevSelectedTickets.includes(clickedTicket)) {
        return prevSelectedTickets.filter(
          (ticketId) => ticketId !== clickedTicket
        );
      } else {
        return [...prevSelectedTickets, clickedTicket];
      }
    });
  };

  const ticketsCounter = (action, contentStatus, ticketId) => {
    if (contentStatus !== status) return;

    switch (action) {
      case "delete":
        // Remove o ticketId se ele existir no array
        setTotalTickets((prev) => prev.filter((ticket) => ticket !== ticketId));
        break;

      case "update":
        // Adiciona o ticketId se ele ainda não estiver no array
        setTotalTickets((prev) => {
          return prev.includes(ticketId) ? prev : [...prev, ticketId];
        });
        break;

      default:
        console.warn(`Unknown action: ${action}`);
        break;
    }
  };

  const { tickets, hasMore, contacts, loading, setLoading } = useTickets({
    pageNumber,
    searchParam,
    tagsFilter,
    status,
    connectionsAndQueues,
    onlyGroups,
    onlyExpiredWaBusiness,
    searchByMessages,
  });

  useEffect(() => {
    if (!status && !searchParam) return;

    let minimizeTicket = false;

    const filteredTickets = FilteredTickets(
      tickets,
      tagsFilter,
      user,
      connectionsAndQueues,
      status,
      onlyGroups
    );

    // Limpa tickets que não pertencem mais aos filtros
    if (connectionsAndQueues?.length > 0) {
      const currentTickets = ticketsList.filter((t) =>
        belongsToUserQueues(t, connectionsAndQueues)
      );
      if (currentTickets.length !== ticketsList.length) {
        dispatch({ type: "RESET" });
      }
    }

    if (filteredTickets.length === 0 && pageNumber == 1) {
      dispatch({ type: "RESET" });
      setPageNumber(1);
      minimizeTicket = true;
    } else {
      if (onlyGroups == true || onlyExpiredWaBusiness == true || !status)
        dispatch({ type: "RESET" });
      dispatch({ type: "LOAD_TICKETS", payload: filteredTickets });
      const currentUuid = GetUrlTicketPath();
      if (filteredTickets.findIndex((ft) => ft.uuid == currentUuid) == -1) {
        minimizeTicket = true;
      }
    }

    if (
      Array.isArray(tickets) &&
      tickets.length > 0 &&
      minimizeTicket == true &&
      status == selectedStatus
    ) {
      history.push("/tickets");
    }
  }, [
    tickets,
    status,
    searchParam,
    user,
    tagsFilter,
    connectionsAndQueues,
    onlyGroups,
    onlyExpiredWaBusiness,
    searchByMessages,
  ]);

  // resgatar contatos pesquisados
  useEffect(() => {
    if (contacts && Array.isArray(contacts) && contacts.length > 0)
      setSearchContacts(contacts);
    else setSearchContacts([]);
  }, [contacts]);

  const belongsToUserQueues = (ticket, connectionsAndQueues) => {
    // 1. Primeiro verifica se o status do ticket corresponde ao tab ativo
    if (status && ticket?.status !== status) return false;

    // 2. Se não há filtro de conexões/filas aplicado, mostra todos os tickets
    if (!connectionsAndQueues?.length) return true;

    // 3. Encontra a conexão específica do ticket
    const conn = connectionsAndQueues.find(
      (c) => c.connectionId === ticket.whatsappId
    );

    // 4. Se não encontrou a conexão, não mostra o ticket
    if (!conn) return false;

    // 5. Se a conexão existe mas não tem filas selecionadas, não mostra nenhum ticket
    if (!conn.queueIds?.length) return false;

    // 6. Finalmente verifica se a fila do ticket está nas filas selecionadas
    return conn.queueIds.includes(ticket.queueId);
  };

  const handleSocketEvents = (
    data,
    user,
    queues,
    profile,
    status,
    tagsFilter,
    connectionsAndQueues,
    adminId
  ) => {
    let ticket = data.ticket;
    if (!ticket && data?.Ticket) ticket = data.Ticket;
    if (!ticket && data?.message?.Ticket) ticket = data.message.Ticket;

    switch (data.action) {
      case "updateUnread":
        dispatch({
          type: "RESET_UNREAD",
          payload: {
            ticketId: data.ticketId,
            lastMessage: data.ticket.lastMessage,
          },
          status,
        });
        break;

      case "update":
        const filteredUpdateTicket = FilteredTickets(
          [ticket],
          tagsFilter,
          user,
          connectionsAndQueues,
          status
        );
        if (filteredUpdateTicket.length > 0) {
          ticketsCounter(
            "update",
            data.content?.status || ticket?.status,
            ticket.id
          );
          if (
            (status != "closed" && user.id == ticket?.userId) ||
            !ticket?.userId ||
            ticket?.isGroup ||
            (ticket?.status == "closed" && status == "closed") || 
            !status && searchParam
          ) {
            dispatch({
              type: "UPDATE_TICKET",
              payload: filteredUpdateTicket[0],
              transfer: data.transfer,
              status,
            });
          }
        }
        if (
          (connectionsAndQueues.length > 0 && belongsToUserQueues(ticket, connectionsAndQueues) == false) ||
          (status && status != "closed" && ticket?.userId != null && ticket?.userId != user.id)
        ) {
          if (ticket?.id) {
            dispatch({ type: "DELETE_TICKET", payload: ticket.id, status });
            ticketsCounter("delete", data.content?.status || ticket?.status, ticket?.id || data?.content?.ticketId);
          }
        }
        break;

      case "delete":
        if (data.oldStatus === status) {
          dispatch({ type: "DELETE_TICKET", payload: data.ticketId, status });
          if (ticket?.inChatbotFlow != true)
            ticketsCounter("delete", data.oldStatus, data.ticketId);
        }
        break;

      case "create":
        if ((!status || status == "undefined") && searchParam?.length > 0)
          return;
        const filteredCreatedTicket = FilteredTickets(
          [ticket],
          tagsFilter,
          user,
          connectionsAndQueues,
          status
        );
        if (filteredCreatedTicket.length > 0) {
          dispatch({
            type: "UPDATE_TICKET_UNREAD_MESSAGES",
            payload: filteredCreatedTicket[0],
            status,
          });
        }
        break;

      case "updateContact":
        dispatch({
          type: "UPDATE_TICKET_CONTACT",
          payload: data.contact,
          status,
        });
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    
    const handleTicketUpdate = (data) =>
      handleSocketEvents(
        data,
        user,
        queues,
        profile,
        status,
        tagsFilter,
        connectionsAndQueues,
        adminId
      );
    const handleContactUpdate = (data) =>
      handleSocketEvents(
        { ...data, action: "updateContact" },
        user,
        queues,
        profile,
        status,
        tagsFilter,
        connectionsAndQueues,
        adminId
      );

    socket.on(`ticket-${adminId}`, handleTicketUpdate);
    socket.on(`contact-${adminId}`, handleContactUpdate);

    return () => {
      socket.off(`ticket-${adminId}`, handleTicketUpdate);
      socket.off(`contact-${adminId}`, handleContactUpdate);
    };
  }, [
    status,
    showAll,
    user,
    profile,
    queues,
    tagsFilter,
    adminId,
    searchParam,
    connectionsAndQueues,
  ]);

  const loadMore = () => {
    setLoading(true);
    setPageNumber(pageNumber + 1);
  };

  const handleScroll = (e) => {
    if (!hasMore || loading || searchParam) return;

    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

    if (scrollHeight - (scrollTop + 100) < clientHeight) {
      loadMore();
    }
  };

  const ticketsArray = removeDuplicated(ticketsList, status);

  return (
    <div className={classes.ticketsListWrapper}>
      <Paper
        square
        name="closed"
        elevation={0}
        className={classes.ticketsList}
        onScroll={handleScroll}
      >
        <List
          style={{ paddingTop: 0, paddingBottom: !status ? 60 : 0 }}
          id="ticketList"
        >
          {status === "open" && (
            <ListSubheader
              style={{ height: "35px", zIndex: 5 }}
              className={classes.ticketsListHeader}
            >
              <div>
                {i18n.t("ticketsList.assignedHeader")}
                <span className={classes.ticketsCount}>
                  {!Array.isArray(totalTickets) || totalTickets.length == 0
                    ? ticketsArray.length
                    : `${ticketsArray.length}/${totalTickets.length}`}
                </span>
              </div>

              <Grid style={{ display: "block" }}>
                {status === "open" && selectedTickets.length > 0 && (
                  <SelectAction
                    status={status}
                    selectedTickets={selectedTickets}
                    onTransferToAwait={() =>
                      GeneralActions("pending", { selectedTickets }, () => {
                        setSelectedTickets([]);
                        toast.success("Atualizado com sucesso!");
                        history.push("/tickets");
                      })
                    }
                    onConcludeTicket={() => showBatchConclusionMessages()}
                    onTagModal={() => showTagModalOpen()}
                    onRemoveTags={() =>
                      GeneralActions("removeTags", { selectedTickets }, () => {
                        setSelectedTickets([]);
                        toast.success("Atualizado com sucesso!");
                        history.push("/tickets");
                      })
                    }
                    onUnread={() =>
                      GeneralActions("setUnread", { selectedTickets }, () => {
                        setSelectedTickets([]);
                        toast.success("Atualizado com sucesso!");
                        history.push("/tickets");
                      })
                    }
                    onTransfer={() => showBatchTransferModal()}
                  />
                )}

                <Tooltip title="Selecionar Todos os Atendimentos">
                  <CheckBoxIcon
                    className={classes.actionIcons}
                    margin="dense"
                    variant="outlined"
                    color="action"
                    onClick={handleSelectAll}
                    style={{
                      color:
                        selectedTickets.length == ticketsList.length
                          ? "#0b708c"
                          : "rgb(67, 83, 105)",
                    }}
                  />
                </Tooltip>
                <Tooltip title="Não Respondidos">
                  <MarkUnreadChatAltIcon
                    className={classes.actionIcons}
                    onClick={() => {
                      pressed === true ? setPressed(false) : setPressed(true);
                    }}
                    style={{
                      cursor: "pointer",
                      color: pressed == true ? "#0b708c" : "rgb(67, 83, 105)",
                      height: "20px",
                      width: "20px",
                    }}
                  />
                </Tooltip>
                <Tooltip
                  title={
                    onlyGroups === true ? "Todos Usuários" : "Apenas Grupos"
                  }
                >
                  <GroupIcon
                    className={classes.actionIcons}
                    onClick={() => {
                      onlyGroups === true
                        ? setOnlyGroups(false)
                        : setOnlyGroups(true);
                    }}
                    style={{
                      color:
                        onlyGroups == true ? "#0b708c" : "rgb(67, 83, 105)",
                      cursor: "pointer",
                      height: "20px",
                      width: "20px",
                    }}
                  />
                </Tooltip>
                {hasWaBusinessModule && (
                  <Tooltip title="Conversas Expiradas">
                    <SmsFailedIcon
                      className={classes.actionIcons}
                      onClick={() => {
                        onlyExpiredWaBusiness === true
                          ? setOnlyExpiredWaBusiness(false)
                          : setOnlyExpiredWaBusiness(true);
                      }}
                      style={{
                        color:
                          onlyExpiredWaBusiness == true
                            ? "#0b708c"
                            : "rgb(67, 83, 105)",
                        cursor: "pointer",
                        height: "20px",
                        width: "20px",
                      }}
                    />
                  </Tooltip>
                )}
                <Tooltip title="Ordenar por Data">
                  <SortByAlphaIcon
                    className={classes.actionIcons}
                    onClick={() => {
                      order === "ASC" ? setOrder("DESC") : setOrder("ASC");
                    }}
                    style={{
                      color: order == "DESC" ? "#0b708c" : "rgb(67, 83, 105)",
                    }}
                  >
                    <Icon
                      style={{
                        cursor: "pointer",
                        marginLeft: "2px",
                        height: "20px",
                      }}
                      margin="dense"
                      variant="outlined"
                      color="action"
                    />
                  </SortByAlphaIcon>
                </Tooltip>
              </Grid>
            </ListSubheader>
          )}
          {status === "pending" && (
            <ListSubheader
              style={{ height: "35px", zIndex: 5 }}
              className={classes.ticketsListHeader}
            >
              <div>
                {i18n.t("ticketsList.pendingHeader")}
                <span className={classes.ticketsCount}>
                  {!Array.isArray(totalTickets) || totalTickets.length == 0
                    ? ticketsArray.length
                    : `${ticketsArray.length} / ${totalTickets.length}`}
                </span>
              </div>
              <Grid>
                {status === "pending" && selectedTickets.length > 0 && (
                  <SelectAction
                    status={status}
                    selectedTickets={selectedTickets}
                    onOpen={() =>
                      GeneralActions(
                        "open",
                        { userId: user.id, selectedTickets },
                        () => {
                          setSelectedTickets([]);
                          toast.success("Atualizado com sucesso!");
                          history.push("/tickets");
                        }
                      )
                    }
                    onConcludeTicket={() => showBatchConclusionMessages()}
                    onTagModal={() => showTagModalOpen()}
                    onRemoveTags={() =>
                      GeneralActions("removeTags", { selectedTickets }, () => {
                        setSelectedTickets([]);
                        toast.success("Atualizado com sucesso!");
                        history.push("/tickets");
                      })
                    }
                    onUnread={() =>
                      GeneralActions("setUnread", { selectedTickets }, () => {
                        setSelectedTickets([]);
                        toast.success("Atualizado com sucesso!");
                        history.push("/tickets");
                      })
                    }
                  />
                )}

                <Tooltip title="Selecionar Todos os Atendimentos">
                  <CheckBoxIcon
                    className={classes.actionIcons}
                    margin="dense"
                    variant="outlined"
                    color="action"
                    onClick={handleSelectAll}
                    style={{
                      color:
                        selectedTickets.length == ticketsList.length
                          ? "#0b708c"
                          : "rgb(67, 83, 105)",
                    }}
                  />
                </Tooltip>
                <Tooltip title="Não Respondidos">
                  <MarkUnreadChatAltIcon
                    className={classes.actionIcons}
                    onClick={() => {
                      pressed === true ? setPressed(false) : setPressed(true);
                    }}
                    style={{
                      cursor: "pointer",
                      color: pressed == true ? "#0b708c" : "rgb(67, 83, 105)",
                      height: "20px",
                      width: "20px",
                    }}
                  />
                </Tooltip>
                <Tooltip
                  title={
                    onlyGroups === true ? "Todos Usuários" : "Apenas Grupos"
                  }
                >
                  <GroupIcon
                    className={classes.actionIcons}
                    onClick={() => {
                      onlyGroups === true
                        ? setOnlyGroups(false)
                        : setOnlyGroups(true);
                    }}
                    style={{
                      color:
                        onlyGroups == true ? "#0b708c" : "rgb(67, 83, 105)",
                      cursor: "pointer",
                      height: "20px",
                      width: "20px",
                    }}
                  />
                </Tooltip>
                {hasWaBusinessModule && (
                  <Tooltip title="Conversas Expiradas">
                    <SmsFailedIcon
                      className={classes.actionIcons}
                      onClick={() => {
                        onlyExpiredWaBusiness === true
                          ? setOnlyExpiredWaBusiness(false)
                          : setOnlyExpiredWaBusiness(true);
                      }}
                      style={{
                        color:
                          onlyExpiredWaBusiness == true
                            ? "#0b708c"
                            : "rgb(67, 83, 105)",
                        cursor: "pointer",
                        height: "20px",
                        width: "20px",
                      }}
                    />
                  </Tooltip>
                )}

                <Tooltip title="Ordenar por Data">
                  <SortByAlphaIcon
                    className={classes.actionIcons}
                    onClick={() => {
                      order === "ASC" ? setOrder("DESC") : setOrder("ASC");
                    }}
                    style={{
                      color: order == "DESC" ? "#0b708c" : "rgb(67, 83, 105)",
                    }}
                  >
                    <Icon
                      style={{
                        cursor: "pointer",
                        marginLeft: "2px",
                        height: "20px",
                      }}
                      margin="dense"
                      variant="outlined"
                      color="action"
                    />
                  </SortByAlphaIcon>
                </Tooltip>
              </Grid>
            </ListSubheader>
          )}
          {status === "closed" && (
            <ListSubheader
              style={{ height: "35px", zIndex: 5 }}
              className={classes.ticketsListHeader}
            >
              <div>
                Finalizados
                <span className={classes.ticketsCount}>
                  {!Array.isArray(totalTickets) || totalTickets.length == 0
                    ? ticketsArray.length
                    : `${ticketsArray.length} / ${totalTickets.length}`}
                </span>
              </div>
              <Grid style={{ display: "flex" }}>
                {status === "closed" && selectedTickets.length > 0 && (
                  <SelectAction
                    status={status}
                    selectedTickets={selectedTickets}
                    onOpen={() =>
                      GeneralActions(
                        "open",
                        { userId: user.id, selectedTickets },
                        () => {
                          setSelectedTickets([]);
                          toast.success("Atualizado com sucesso!");
                          history.push("/tickets");
                        }
                      )
                    }
                    onTagModal={() => showTagModalOpen()}
                    onRemoveTags={() =>
                      GeneralActions("removeTags", { selectedTickets }, () => {
                        setSelectedTickets([]);
                        toast.success("Atualizado com sucesso!");
                        history.push("/tickets");
                      })
                    }
                    onUnread={() =>
                      GeneralActions("setUnread", { selectedTickets }, () => {
                        setSelectedTickets([]);
                        toast.success("Atualizado com sucesso!");
                        history.push("/tickets");
                      })
                    }
                  />
                )}

                <Tooltip title="Selecionar Todos os Atendimentos">
                  <CheckBoxIcon
                    className={classes.actionIcons}
                    margin="dense"
                    variant="outlined"
                    color="action"
                    onClick={handleSelectAll}
                    style={{
                      color:
                        selectedTickets.length == ticketsList.length
                          ? "#0b708c"
                          : "rgb(67, 83, 105)",
                    }}
                  />
                </Tooltip>
                <Tooltip title="Não Respondidos">
                  <MarkUnreadChatAltIcon
                    className={classes.actionIcons}
                    onClick={() => {
                      pressed === true ? setPressed(false) : setPressed(true);
                    }}
                    style={{
                      cursor: "pointer",
                      color: pressed == true ? "#0b708c" : "rgb(67, 83, 105)",
                      height: "20px",
                      width: "20px",
                    }}
                  />
                </Tooltip>
                <Tooltip
                  title={
                    onlyGroups === true ? "Todos Usuários" : "Apenas Grupos"
                  }
                >
                  <GroupIcon
                    className={classes.actionIcons}
                    onClick={() => {
                      onlyGroups === true
                        ? setOnlyGroups(false)
                        : setOnlyGroups(true);
                    }}
                    style={{
                      color:
                        onlyGroups == true ? "#0b708c" : "rgb(67, 83, 105)",
                      cursor: "pointer",
                      height: "20px",
                      width: "20px",
                    }}
                  />
                </Tooltip>
                {hasWaBusinessModule && (
                  <Tooltip title="Conversas Expiradas">
                    <SmsFailedIcon
                      className={classes.actionIcons}
                      onClick={() => {
                        onlyExpiredWaBusiness === true
                          ? setOnlyExpiredWaBusiness(false)
                          : setOnlyExpiredWaBusiness(true);
                      }}
                      style={{
                        color:
                          onlyExpiredWaBusiness == true
                            ? "#0b708c"
                            : "rgb(67, 83, 105)",
                        cursor: "pointer",
                        height: "20px",
                        width: "20px",
                      }}
                    />
                  </Tooltip>
                )}

                <Tooltip title="Ordenar por Data">
                  <SortByAlphaIcon
                    className={classes.actionIcons}
                    onClick={() => {
                      order === "ASC" ? setOrder("DESC") : setOrder("ASC");
                    }}
                    style={{
                      color: order == "DESC" ? "#0b708c" : "rgb(67, 83, 105)",
                    }}
                  >
                    <Icon
                      style={{
                        cursor: "pointer",
                        marginLeft: "2px",
                        height: "20px",
                      }}
                      margin="dense"
                      variant="outlined"
                      color="action"
                    />
                  </SortByAlphaIcon>
                </Tooltip>
              </Grid>
            </ListSubheader>
          )}
          {ticketsArray.length === 0 &&
            searchContacts.length === 0 &&
            !loading ? (
            <div className={classes.noTicketsDiv}>
              <span className={classes.noTicketsTitle}>
                {i18n.t("ticketsList.noTicketsTitle")}
              </span>
              <p className={classes.noTicketsText}>
                {i18n.t("ticketsList.noTicketsMessage")}
              </p>
            </div>
          ) : (
            <>
              {searchContacts.length > 0 && (
                <Box>
                  <Typography className={classes.contactTitle}>
                    Contatos
                  </Typography>
                  {searchContacts.map((contact) => {
                    return <ContactListItem contact={contact} />;
                  })}
                  <Typography 
                    className={classes.contactTitle}
                    sx={{
                      position: "relative"
                    }}
                  >
                    Atendimentos

                    <Box
                      sx={{
                        position: "absolute",
                        right: "24px",
                        top: "0"
                      }}
                    >
                      {
                        Array.isArray(selectedTickets) && selectedTickets.length > 0
                        &&
                        <SelectAction
                          status={status}
                          selectedTickets={selectedTickets}
                          onOpen={() => GeneralActions("open", { userId: user.id, selectedTickets }, () => { unSelectAll(); toast.success(i18n.t("ticketManagement.messages.successfullyUpdated")); })}
                          onTransferToAwait={() => GeneralActions("pending", { selectedTickets }, () => { unSelectAll(); toast.success(i18n.t("ticketManagement.messages.successfullyUpdated")); })}
                          onConcludeTicket={() => showBatchConclusionMessages()}
                          onTagModal={() => showTagModalOpen()}
                          onRemoveTags={() => GeneralActions("removeTags", { selectedTickets }, () => { unSelectAll(); toast.success(i18n.t("ticketManagement.messages.successfullyUpdated")); })}
                          onUnread={() => GeneralActions("setUnread", { selectedTickets }, () => { unSelectAll(); toast.success(i18n.t("ticketManagement.messages.successfullyUpdated")); })}
                          onTransfer={() => showBatchTransferModal()}
                        />
                      }

                      <Tooltip title="Selecionar Todos os Atendimentos">
                        <CheckBoxIcon
                          className={classes.actionIcons}
                          margin="dense"
                          variant="outlined"
                          color="action"
                          onClick={handleSelectAll}
                          style={{
                            color: selectedTickets.length == ticketsList.length ? "#0b708c" : "rgb(67, 83, 105)",
                          }}
                        />
                      </Tooltip>
                    </Box>
                  </Typography>
                </Box>
              )}
              {pressed == false
                ? sortedTicketList.map((ticket, index) => (
                  <TicketListItem
                    // ticket={{
                    //   ...ticket,
                    //   draft: drafts.find((df) => df.uuid == ticket.uuid)
                    //     ?.text,
                    // }}
                    ticket={ticket}
                    key={ticket.id}
                    index={index}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCheckboxChange(ticket.id);
                    }}
                    checked={selectedTickets.includes(+ticket.id)}
                    hiddenCheckboxOption={false}
                    searchingByParam={
                      searchParam && String(searchParam).trim() != ""
                        ? true
                        : false
                    }
                  />
                ))
                : sortedUnreadTickets.map((ticket) => (
                  <TicketListItem
                    // ticket={{
                    //   ...ticket,
                    //   draft: drafts.find((df) => df.uuid == ticket.uuid)
                    //     ?.text,
                    // }}
                    ticket={ticket}
                    key={ticket.id}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleCheckboxChange(ticket.id);
                    }}
                    checked={selectedTickets.includes(+ticket.id)}
                    hiddenCheckboxOption={false}
                    searchingByParam={
                      searchParam && String(searchParam).trim() != ""
                        ? true
                        : false
                    }
                  />
                ))}
            </>
          )}
          {loading && <TicketsListSkeleton />}
        </List>
      </Paper>

      {/* modals for SelectAction */}
      <BatchConclusionMessages
        open={conclusionModalOpen}
        handleClose={hideBatchConclusionMessages}
        onConcludeTicket={GeneralActions}
        selectedTickets={selectedTickets}
        onConcludeClean={() => {
          toast.success("Atualizado com sucesso!");
          hideBatchConclusionMessages();
          setSelectedTickets([]);
          history.push("/tickets");
        }}
      />

      <BatchTagModal
        open={tagModalOpen}
        onClose={hideTagModalOpen}
        onSave={GeneralActions}
        selectedTickets={selectedTickets}
      />

      <BatchTransferModal
        tcktIds={selectedTickets}
        onClose={hideBatchTransferModal}
        onSuccess={() => {
          setSelectedTickets([]);
          toast.success("Atualizado com sucesso!");
        }}
        open={
          transferModalOpen == true && selectedTickets.length > 0 ? true : false
        }
      />
    </div>
  );
};

export default TicketsList;
